<template>
  <vodal :show="show"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :closeButton="false"
         :width="600"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto', 'max-width': '96%'}"
         @hide="$emit('hide-dialog')"
         id="confirmDialog-dialog">
    <p>{{ textLabel | translate }}</p>
    <hr>
    <div class="text-right" id="confirmDialog-dialog-div">
      <button class="btn btn-sm btn-primary" @click="$emit('confirm')" id="confirmDialog-confirmButton">{{ 'dialog.YES' | translate }}</button>
      <button class="btn btn-sm btn-default" @click="$emit('hide-dialog')" id="confirmDialog-hide-dialog">{{ 'dialog.NO' | translate }}</button>
    </div>
  </vodal>
</template>

<script>
import Vodal from 'vodal';

export default {
  name: 'ConfirmDialog',
  components: { Vodal },
  props: ['show', 'textLabel']
}
</script>

<style scoped>
p {
  font-size: 1rem;
}
.btn {
  min-width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/ConfirmDialog.vue